import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "boolean"
})
export class BoolenaPipe implements PipeTransform {
  transform(value: any,true_control:any, true_value:any, false_value:any): any {
    return value === true_control? true_value : false_value;
  }
}